<template>
  <div class="text-center">
    <v-dialog v-model="shower" max-width="500" persistent>
      <v-card>
        <v-card-title :style="'background:' + _cardTitle">
          <span v-if="type == 'support'">
            {{ $t("package.swal.problem_support") }}
          </span>
          <span v-else>{{ $t("package.swal.problem_sale") }}</span>
          <v-spacer></v-spacer>
          <v-btn color="#f05c5a" @click="fn_close()" fab small dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-center">
          <v-form ref="forms">
            <p class="text-start font-weight mt-5">
              {{ $t("package.swal.email_contact") }}
              <v-text-field
                class="my-input"
                outlined
                dense
                append-icon="mdi-email"
                hide-details="auto"
                v-model="email"
                :rules="emailRules"
                required
                clearable
                @input="fn_checkRegex()"
                :error-messages="regex"
              ></v-text-field>
            </p>
            <p class="text-start font-weight mt-3">
              {{ $t("report_problem.condition.condition_tel") }}
              <v-text-field
                class="my-input"
                v-mask="mask"
                outlined
                dense
                append-icon="mdi-phone"
                v-model="tel"
                hide-details="auto"
                :rules="telRules"
                required
              ></v-text-field>
            </p>
            <p class="text-start font-weight mt-3">
              {{ $t("report_problem.condition.condition_topic") }}
              <v-text-field
                class="my-input"
                outlined
                dense
                append-icon="mdi-menu"
                v-model="topicProblem"
                hide-details="auto"
                :rules="titleRules"
                required
              ></v-text-field>
            </p>
            <p class="text-start font-weight mt-3">
              {{ $t("report_problem.condition.condition_details") }}
              <v-textarea
                class="my-input"
                outlined
                rows="3"
                dense
                v-model="descriptionProblem"
                hide-details="auto"
                :rules="desRules"
                auto-grow
                required
                append-icon="mdi-message-alert"
              ></v-textarea>
            </p>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="ma-2">
            <v-btn color="#f05c5a" outlined @click="fn_close()"> {{ $t("settingLogo.condition.btnCancle") }}</v-btn>
            <v-btn
              :color="_pageDetailcolor"
              :loading="loading"
              class="mx-2"
              dark
              @click="fn_save()"
              >  {{ $t("settingLogo.condition.btnSave") }}</v-btn
            >
          </div>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import authorization from "@/authorization/authorization.js";
import { mapState } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: [
    "show",
    "sellerId",
    "userCode",
    "taxId",
    "emailProblem",
    "telProblem",
    "topicProblem",
    "type",
  ],
  data: function () {
    return {
      tel: "",
      email: "",
      mask: "###-#######",
      descriptionProblem: "",
      regex: "",
      titleRules: [(v) => !!v || this.$t("report_problem.swal.enter_issue")],
      desRules: [(v) => !!v || this.$t("report_problem.swal.enter_problem")],
      telRules: [
        (v) =>
          (!!v && v.length > 9) || this.$t("report_problem.swal.enter_tel"),
      ],
      emailRules: [
        (v) => !!v || this.$t("report_problem.swal.enter_email"),
        (v) => /.+@.+/.test(v) || this.$t("report_problem.swal.err_email"),
      ],
      telephoneRegex:
        "this.value = this.value.replace(/[^0-9+/-]|/g, '').substr(0,15)",
      loading: false,
    };
  },
  watch: {
    telProblem(val) {
      if (val === null) {
        this.tel = "";
      } else {
        this.tel = val;
      }
    },
    // emailProblem(val) {
    //   this.email = val;
    // },
  },
  computed: {
    ...mapState(["pageDetailcolor", "cardTitle"]),
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _cardTitle: {
      get() {
        return this.cardTitle;
      },
    },
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogDelete");
        }
      },
    },
  },
  methods: {
    async fn_save() {
      if (this.$refs.forms.validate()) {
        this.loading = true;
        var payload = {
          seller_id: this.sellerId,
          usercode: this.userCode,
          taxid: this.taxId,
          seller_branch_id: "00000",
          email_reply: this.email,
          email_receiver: this.emailProblem,
          detail: this.descriptionProblem,
          title: this.topicProblem,
          tel: this.tel,
        };
        //console.log("payload ::", payload);
        var auth = await authorization.gentoken(this.taxId);
        var headers = { Authorization: "Bearer " + auth };
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_GETDATA_API + "etax-problem",
            payload,
            { headers }
          )
          .then((res) => {
            //console.log("res ::", res);
            this.loading = false;
            if (res.data.status === "OK") {
              swal({
                title: "Success",
                text: this.$t("package.swal.success"),
                icon: "success",
              });
              this.fn_close();
            } else {
              swal({
                title: this.$t("package.swal.errorTitle"),
                text: res.data.errorMessage,
                icon: "error",
              });
            }
          })
          .catch((error) => {
            //console.log(error);
            this.loading = false;
            swal({
              title: this.$t("package.swal.errorTitle"),
              text: error.response.data.errorMessage,
              icon: "error",
            });
          });
      }
    },
    fn_close() {
      this.descriptionProblem = "";
      this.email = "";
      this.loading = false;
      this.regex = "";
      this.$refs.forms.resetValidation();
      this.$emit("close");
    },
    fn_checkRegex() {
      var mail = this.email.split(",");
      for (var i of mail) {
        const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        var check = re.test(String(i).toLowerCase());
        if (check == false) {
          this.regex = this.$t("dialogEmail.regex");
        } else {
          this.regex = "";
        }
      }
    },
  },
};
</script>
